// Remember-me aware storage for the Supabase auth session.
//
// WHY THIS FILE EXISTS: CostSpace and Estimation each create their own Supabase client, but both point at the
// same project, so both read/write the SAME session key. They MUST share one storage policy - if only one of
// them were session-only, the other would not find the session and would send requests as "anonymous".
// Both clients therefore import this single adapter.
//
//   "Remember me" ticked   -> session kept in localStorage      (survives closing the browser)   [default]
//   "Remember me" unticked -> session kept in sessionStorage    (gone when the browser/tab closes)
//
// The user's choice is stored under FLAG in localStorage. Existing sessions (created before this file existed)
// live in localStorage and keep working: getItem() looks in both places.
const FLAG = 'costspace_remember_me' // '0' = session only; anything else / missing = remembered

const local = () => { try { return window.localStorage } catch (e) { return null } }
const session = () => { try { return window.sessionStorage } catch (e) { return null } }

export function isRememberMe() {
  try { return local()?.getItem(FLAG) !== '0' } catch (e) { return true }
}

export function setRememberMe(remember) {
  try { local()?.setItem(FLAG, remember ? '1' : '0') } catch (e) { /* storage blocked: nothing to persist */ }
}

export const authStorage = {
  getItem(key) {
    return session()?.getItem(key) ?? local()?.getItem(key) ?? null
  },
  setItem(key, value) {
    if (isRememberMe()) { local()?.setItem(key, value); session()?.removeItem(key) }
    else { session()?.setItem(key, value); local()?.removeItem(key) }
  },
  removeItem(key) {
    session()?.removeItem(key)
    local()?.removeItem(key)
  },
}
